import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { pathNameKeygen, bindKeywordArguments, getItemFromPagination } from '../actions'

import { denormalize } from 'normalizr'

import get from 'lodash/get'

export default function connectPagination({
  entitykey,
  loadItems,
  keygen,
  itemSchema,
  getQueryParams,
  title,
}) {
  return DecoratedComponent => {
    class ConnectPagination extends React.Component {

      _getQueryParams(props) {
        const { location, state } = props
        return getQueryParams ? getQueryParams({state, ownProps: props}) : location.query
      }

      componentDidMount() {
        const { loadItems } = this.props
        loadItems({index: 0, queryParams: this._getQueryParams(this.props)})
      }

      componentWillReceiveProps(nextProps) {
        const { loadItems } = nextProps
        if (!nextProps.pagination) {
          loadItems({index: 0, queryParams: this._getQueryParams(nextProps), keygen})
        }
      }

      _getItem = ({index}) => {
        const { pagination, loadItems, entities, state } = this.props
        
        const item = getItemFromPagination(pagination, entities, index)

        if(!item || item.isStale) {
          setTimeout(() => loadItems({
            index, 
            queryParams: this._getQueryParams(this.props),
            forceRefresh: true,
          }), 0)          
        }

        return item ? denormalize(item[itemSchema.idAttribute], itemSchema, state.entities ) : {index, loading: true}
      }

      render() {
        const { pagination } = this.props

        if(!pagination) {
          return <span className='timer-loader'></span>
        }

        return (
          <DecoratedComponent 
            getItem={this._getItem} 
            totalItems={pagination.totalItems || 0}
            {...this.props}
          />
        )
      }
    }

    const _keygen = keygen || pathNameKeygen

    const mapStateToProps = function(state, ownProps) {
      const paginationKey = _keygen({state, ownProps})
      const pagination = get(state, ['pagination', entitykey, paginationKey])

      return {
        entities: state.entities[entitykey],
        pagination,
        state,
        location: state.routing.locationBeforeTransitions,
      }
    }

    const mapDispatchToProps = function(dispatch, ownProps) {
      return bindActionCreators({
        loadItems: bindKeywordArguments(
          ownProps.loadItems || loadItems, 
          {keygen: _keygen, ownProps}
        )
      }, dispatch);
    }

    return connect(mapStateToProps, mapDispatchToProps)(ConnectPagination)
  }
}


// WEBPACK FOOTER //
// ./src/decorators/connectPagination.js